export default "__VITE_ASSET__BYJP9hMO__"